export default {
  flock_app_store: 'Flock App Store',
  get_more_apps: 'Get more apps',
  app_store_button_label: 'Apps',
  directory_button_label: 'Directory',
  roster_title: 'Channels & Contacts',
};
